import { RegionShared } from "@1games-ru/region-shared";
import { useCallback, useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";

export function useShowBankATM() {
  const [isOpen, setIsOpen] = useState(false);
  const [atmId, setAtmId] = useState<number | null>(null);

  const close = useCallback(() => {
    GameMpProvider.closeCurrentInterface(true);
  }, []);

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Bank.BankAtmShow,
      (state: typeof RegionShared.Cef.Requests.BankAtmShowRequest) => {
        setIsOpen(true);
        setAtmId(state.atmId);
      },
    );

    rpc.register(RegionShared.Cef.Events.Bank.BankAtmHide, () => setIsOpen(false));

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Bank.BankAtmShow);
      rpc.unregister(RegionShared.Cef.Events.Bank.BankAtmHide);
    };
  }, []);

  return { isOpen, atmId, close };
}
